import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Four04 } from 'gossamer-front-end';
import { LocationSearch } from './LocationSearch';
import { LocationDisplay } from './LocationDisplay';
import { LocationCreate } from './LocationCreate';
import { LocationUpdate } from './LocationUpdate';
import { LocationSetCoordinates } from './LocationSetCoordinates';

/**
 * Location Routes
 *
 * Routing for location management pages
 */
export const LocationRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/search" element={<LocationSearch />} />
    <Route path="/create" element={<LocationCreate />} />
    <Route path="/display/:key" element={<LocationDisplay />} />
    <Route path="/update/:key" element={<LocationUpdate />} />
    <Route path="/set-coordinates/:key" element={<LocationSetCoordinates />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
